<template>
 
   <!-- 导航栏 -->
    <nav class="navbar">
      <div class="nav-container">
        <div class="logo">
       
          <span class="logo-text"><img src="favicon.ico"> </span>
        </div>

        <div class="nav-menu">
          <a
            v-for="item in originalData"
            :key="item.newsClassName"
            :href="item.routePath"
            class="nav-item"
            :class="{ active: Headerscontent === item.newsClassName }"
           
          >
            {{ item.newsClassName }}
          </a>
        </div>

        <div class="nav-right">
        <a 
          class="member-login" 
          :href="isLogin ? '#/console' : '#/login'"
        >
          {{ isLogin ? '我的控制台' : '会员登录' }}
        </a>
        </div>
      </div>
    </nav>
  </template>

  <script setup lang="ts">
  import { cookieHelper } from "@/common/CookieHelper";
  // 导航项数据
const navItems = [
  { name: '首页' },
  { name: '公司动态' },
  { name: '产品介绍' },
  { name: '服务支持' },
  { name: '解决方案' },
  { name: '联系我们' },
  { name: '合作伙伴' }
]

import { Options, Vue } from 'vue-class-component';
 import { Location, Document, Setting, Menu, ArrowRight } from "@element-plus/icons-vue"
 import { createApp, ref, computed, watch, onMounted } from "vue";
 import {
GetListNewsClass
} from "../../httpRequest/newsRequest";;
 const   isLogin = ref(false)  
const originalData = ref([]);
const props = defineProps({
  Headerscontent: {
    type: String,
    required: false,
    default: ''
  }
})

const GetListNewsClassData = async (data: any) => {
  var getListBusinessCategory = await GetListNewsClass({
    ParentId: data
  });
   
  originalData.value = getListBusinessCategory.data;
    
    setHomeSEO(props.Headerscontent)
};
const setHomeSEO= async (data: any) => {
  // 找到 首页 数据
  const home = originalData.value.find(item => item.newsClassName === data)
  
  if (!home) return

  // 设置标题
  document.title = home.newsClassTitle || '公司网站'

  // 设置关键词
  const kwMeta = document.querySelector('meta[name="keywords"]')
  if (kwMeta) kwMeta.content = home.newsClassKey

  // 设置描述
  const descMeta = document.querySelector('meta[name="description"]')
  if (descMeta) descMeta.content = home.newsClassDescribe
}

onMounted(() => {
  GetListNewsClassData("8c0faa9739096fbe4d7deedeab9cd181");
    var token = cookieHelper.getCookie("token");
 isLogin.value =cookieHelper.getCookie("token") ? true : false;
 
 
 
 
})
 const currentPage = ref('首页')
</script>


 <style lang="scss" scoped>
   
        .navbar {
            background: white;
            border-bottom: 1px solid #e0ecff;
            padding: 16px 0;
            position: sticky;
            top: 0;
            z-index: 100;
            box-shadow: 0 4px 12px rgba(0, 51, 102, 0.05);
        }

        .nav-container {
            max-width: 1400px;
            margin: 0 auto;
            padding: 0 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .logo {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .logo-icon {
            background: #0066cc;
            color: white;
            width: 40px;
            height: 40px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 1.3rem;
        }

        .logo-text {
            font-size: 1.2rem;
            font-weight: 600;
            color: #00377a;
        }

      

        .member-login {
            background: #0066cc;
            color: white;
            padding: 10px 24px;
            border-radius: 40px;
            font-weight: 500;
            cursor: pointer;
            transition: 0.2s;
            border: none;
            font-size: 1rem;
        }

        .member-login:hover {
            background: #004c99;
        }
        /* ========== 响应式设计 ========== */
@media (max-width: 992px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .nav-menu {
    display: none;
  }
}

@media (max-width: 768px) {
  .main-content {
    padding: 40px 0;
  }
  
  .login-section,
  .info-block {
    padding: 30px 20px;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 8px;
  }
  
  .separator {
    display: none;
  }
}

@media (max-width: 480px) {
  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

</style>
 